/**
 * 素材多媒体内容展示
 */
import React from 'react';
import { Icon, Loading, OverlayTrigger, PopOver } from '@tencent/spaui';
import { MaterialContentItem } from '../interface';
import { materialContentConfig } from '../config';
import '../assets/index.scoped.less';

const FileList = (props: {
  data: Array<MaterialContentItem>,
  mode?: 'edit' | 'text',
  onDelete?: (index: number) => void,
  onPreview?: (type: string, url: string) => void,
}) => {
  const { data, mode = 'text', onDelete, onPreview } = props;

  return <div className="file-list">
  {
    data?.map((v, i) => {
      const { contentType, url = '', title, status, errorMsg } = v;
      const { type, icon = '' } = materialContentConfig[contentType] || {};
      return <div className="file-item" key={i}>
        <div className="file-content" onClick={() => onPreview?.(type, url)}>
        {
          status === 'fail'
            ? <Icon name="exclamation-filled" color="#e63d2e"/>
            : <i className={`file-icon ${icon}`}></i>
        }
        {
          !errorMsg?.length
            ? <div className="file-name">{title}</div>
            : <OverlayTrigger trigger="hover" overlay={<PopOver>{errorMsg}</PopOver>}>
                <div className="file-name">{title}</div>
            </OverlayTrigger>
        }
        </div>
        {status === 'loading' && <Loading display="inline-block" /> }
        {mode === 'edit' && status !== 'loading' && <span className="file-delete" onClick={(e: any) => onDelete?.(i)}><Icon name="clear-outlined" color="#c4c7cc" /></span>}
      </div>;
    })
  }
  </div>;
};

export default FileList;
